import { WithServerInfo } from '@go-client/context/ServerInfoContext';
import { WithUserInfo } from '@go-client/context/UserInfoContext';
import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { getUserToken } from '../lib/auth';
import { WithPropertyInfo } from '@go-client/context/PropertyInfoContext';
import { WithNotifications } from '@go-client/context/NotificationsContext';
import NotificationOverlay from '@go-client/components/NotificationOverlay';
import { WithActiveProperty } from '@go-client/context/ActivePropertyContext';
import WithImageCropper from '@go-client/context/ImageCropperContext';

export interface PrivateRouteProps {
  loginUrl?: string;
}
export default class PrivateRoute extends React.Component<PrivateRouteProps & RouteProps> {
  public render() {
    let { path, component, location } = this.props;
    let Component = component as typeof React.Component;
    let loginUrl = this.props.loginUrl || '/login';

    const onPropertyMatch = location && location.pathname.match(/^\/property\/([0-9a-z]+)\//);
    const propertyId =
      onPropertyMatch && onPropertyMatch.length > 1 ? onPropertyMatch[1] : undefined;

    const route = <Route path={path} render={props => <Component {...props} />} />;

    // Note that we don't validate the token here, just check if it exists. This
    // is not strictly necessary because we catch 401 errors in `api#apiRequest`
    // and use those to prompt the user to log in again
    return getUserToken() ? (
      <WithServerInfo>
        <WithUserInfo>
          <WithPropertyInfo>
            <WithNotifications>
              <WithImageCropper>
                {propertyId ? (
                  <WithActiveProperty property={propertyId}>{route}</WithActiveProperty>
                ) : (
                  route
                )}
              </WithImageCropper>
              <NotificationOverlay />
            </WithNotifications>
          </WithPropertyInfo>
        </WithUserInfo>
      </WithServerInfo>
    ) : (
      <Redirect to={{ pathname: loginUrl, state: { from: location } }} />
    );
  }
}
